import { render, staticRenderFns } from "./FaqLayer.vue?vue&type=template&id=5df90f3c&scoped=true&name=faq-layer&"
import script from "./FaqLayer.vue?vue&type=script&lang=js&"
export * from "./FaqLayer.vue?vue&type=script&lang=js&"
import style0 from "./FaqLayer.vue?vue&type=style&index=0&id=5df90f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df90f3c",
  null
  
)

/* custom blocks */
import block0 from "./FaqLayer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports